import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { OrderLogResponse } from '@models/order/orderLog';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import OrderItem from './OrderItem';

interface Props {
    orderLog: OrderLogResponse;
}

function OrderItems({ orderLog }:Props) {
    const { t } = useTranslation('orderLog');
    const { orderItems } = orderLog;
    return (
        <Card as='section'>
            <Text size='lg' fontWeight='bold'>{t('items.title')}</Text>
            <Column fullWidth spacing={16}>
                {orderItems.map((orderItem, index) => (
                    <Fragment key={orderItem.itemId}>
                        {index > 0 && <Divider/>}
                        <OrderItem orderItem={orderItem}/>
                    </Fragment>
                ))}
            </Column>
        </Card>
    );
}

const Card = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 16px;
    border: 1px solid ${colors.gray2};
    border-radius: 8px;
    padding: 16px;
    margin: 16px 16px 0;
    width: calc(100% - 32px);
`;

const Divider = styled.div`
    width: 100%;
    height: 1px;
    background-color: ${colors.gray2};
`;

export default OrderItems;
